import React, { useState, useEffect } from "react";
import { SelectedContainer } from "../../../components/styles";
import { ParagraphStyle } from "./../styles";
import { FormRow } from "../../../styles/forms/main";
import { SubmitDeactivate } from "./../api";
import ModalComponent from "./../../../components/modal";
import { setMessage } from "./../../shared/notification/slice";
import TextArea from "./../../../components/textArea";
import CheckBox from "../../../components/checkbox";
import {
    mapSalesDeactivateReasonToData,
    mapSupplyChainDeactivateReasonToData,
} from "./../mapToData";
import { useDispatch, useSelector } from "react-redux";
import { userRoles } from "./../../../constants/userRoles";
import { getUserRoles } from "../../auth/slice";
import trackAnalytics from "../../../trackAnalytics";

export default function DeactivateModal({
    isShow,
    activeWorkingCondition,
    conditionId,
    onHide,
    role,
    status,
    }) {
    const [deactivateReason, setDeactivateReason] = useState({});
    const dispatch = useDispatch();
    const getCurrentUserRoles = useSelector(getUserRoles());

    useEffect(() => {
        setDeactivateReason({});
    }, []);
    const deactivateModalBody = () => {
        return role === userRoles.SALES_REPRESENTATIVE ? (
            <div>
                <FormRow>
                    <ParagraphStyle>
                        If you want to deactivate this working Condition , please select the reasons
                        & write down your comments.
                    </ParagraphStyle>
                </FormRow>
                <FormRow>
                    <SelectedContainer>
                        <FormRow>
                            <CheckBox
                                type="radio"
                                name="deactivate-reason"
                                inputValue="0"
                                label="The client canceled this working condition"
                                onChange={(e) => {
                                    setDeactivateReason({ ...deactivateReason, status: 0 });
                                }}
                            />
                        </FormRow>
                        <FormRow>
                            <CheckBox
                                type="radio"
                                name="deactivate-reason"
                                inputValue="1"
                                label="The client put this working condition on-hold"
                                onChange={(e) => {
                                    setDeactivateReason({ ...deactivateReason, status: 1 });
                                }}
                            />
                        </FormRow>
                    </SelectedContainer>
                </FormRow>
                <FormRow>
                    <TextArea
                        isEditable
                        type="text"
                        name="deactivate-reason"
                        onChange={(e) => {
                            setDeactivateReason({ ...deactivateReason, reason: e.target.value });
                        }}
                        label=""
                        placeholder="write your Reason ....."
                        value={deactivateReason?.reason}
                    />
                </FormRow>
            </div>
        ) : (
            <div>
                <FormRow>
                    <ParagraphStyle>
                        If you want to deactivate this working Condition , please write down the
                        reasons.
                    </ParagraphStyle>
                </FormRow>
                <FormRow>
                    <TextArea
                        isEditable
                        type="text"
                        name="deactivate-reason"
                        onChange={(e) => {
                            setDeactivateReason({ ...deactivateReason, reason: e?.target?.value });
                        }}
                        label=""
                        placeholder="write your Reason ....."
                        value={deactivateReason?.reason}
                    />
                </FormRow>
            </div>
        );
    };
    const SubmitDeactivateStatus = () => {
        const deactivateReasonData =
            role === userRoles.SALES_REPRESENTATIVE
                ? mapSalesDeactivateReasonToData(deactivateReason, conditionId)
                : mapSupplyChainDeactivateReasonToData(deactivateReason, conditionId);
        SubmitDeactivate(deactivateReasonData, conditionId)
            .then(async (res) => {
                dispatch(
                    setMessage({
                        content: `project profile condition deactivated successfully `,
                        isError: false,
                    })
                );
                const salesDeactivationReason =
                    deactivateReasonData?.data?.attributes.deactivationStatus === 0
                        ? "The client canceled this working condition"
                        : deactivateReasonData?.data?.attributes.deactivationStatus === 1
                        ? "The client put this working condition on-hold"
                        : "";
                trackAnalytics("Deactivate working condition submission", {
                    "Deactivation Reason": deactivateReasonData.data.attributes.deactivationReason,
                    "Selected Deactivation Reason": salesDeactivationReason,
                    "Working Condition Status": status,

                });
                window.location.reload(false);
            })
            .catch((error) => {
                dispatch(
                    setMessage({
                        content: error,
                        title: `Couldn't deactivate project profile conditions  `,
                        isError: true,
                    })
                );
            });
        onHide();
    };
    return (
        <ModalComponent
            open={isShow}
            grow
            key="addLocation"
            submitBtn
            cancelBtn
            submitBtnText="submit"
            header={`Deactivate Working Condition #${activeWorkingCondition + 1}`}
            onSubmit={() => {
                SubmitDeactivateStatus();
            }}
            onClose={(e) => {
                e.preventDefault();
                onHide();
            }}
            closeOnClickOutSide
            isFooter
            size="md"
            disabled={deactivateReason.reason === "" || deactivateReason.status === null}
        >
            <div>{deactivateModalBody()}</div>
        </ModalComponent>
    );
}
